// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__-oiTw","contact-inner":"Contact_contact-inner__TncKr"};